import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import OptionMenuToggle from "../theme_reuse/OptionMenuToggle";
import NoteVisibilityModeButton from "../music_controls/custom_buttons/NoteVisibilityModeButton";

interface Props {}
interface State {}

const TITLE = "Hide the notes entirely?";
const shortNames = [false, true];
const descriptions = ["The notes detected appear above the possible chords.", "Note history is hidden."];

function printShortName(x: boolean): string {
  switch (x) {
    case true:
      return "Hide";
    case false:
      return "Show";
  }
}

export default class NoteHideSectionToggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeShowHide = (hideNotes: boolean) => {
    const oldNoteRow = this.context.chordHistoryOptions.noteRow;
    this.context.dispatch({ type: "EditChordHistoryOptions", payload: { noteRow: { ...oldNoteRow, hideNotes } } });
  };

  render(): ReactNode {
    const hideNotes = this.context.chordHistoryOptions.noteRow.hideNotes;
    return (
      <OptionMenuToggle
        title={TITLE}
        optionShortNames={shortNames}
        optionDescriptions={descriptions}
        selected={hideNotes}
        printShortName={printShortName}
        onChange={this.changeShowHide}
        extraInfo={
          <p>
            Shortcut: shift+N to show or hide note history, or press the <NoteVisibilityModeButton /> button.
          </p>
        }
      />
    );
  }
}

NoteHideSectionToggle.contextType = AppContextType;
